@if (dashboard()) {
  @for (breadcrumb of navigationList; track breadcrumb; let last = $last) {
    @if (last && breadcrumb.breadcrumbs !== false) {
      <div class="page-header">
        <div class="page-block">
          <div class="row align-item-center">
            <div class="col-md-12">
              <div class="flex align-item-center">
                <ul class="breadcrumb align-item-center">
                  <li class="breadcrumb-item">
                    @if (type === "theme2") {
                      <a
                        [routerLink]="['/']"
                        title="Home">
                        <i class="ti ti-home-2"></i>
                      </a>
                    }
                    @if (type === "theme1") {
                      <a [routerLink]="['/']">{{ "home" | translate }}</a>
                    }
                  </li>
                  @for (breadcrumb of navigationList; track breadcrumb) {
                    @if (breadcrumb.url !== false) {
                      <li
                        class="breadcrumb-item"
                        [hidden]="!visibility">
                        <a
                          [routerLink]="breadcrumb.url"
                          [fragment]="breadcrumb.fragment">
                          {{ breadcrumb.title | translate }}
                        </a>
                      </li>
                    }
                    @if (breadcrumb.url === false && breadcrumb.type !== "group" && breadcrumb.type !== "collapse") {
                      <li
                        class="breadcrumb-item"
                        [hidden]="!visibility">
                        <span>{{ breadcrumb.title | translate }}</span>
                      </li>
                    }
                  }
                </ul>
              </div>
            </div>
            <div class="col-md-12">
              <div
                class="page-header-title"
                [hidden]="!visibility">
                @for (breadcrumb of navigationList; track breadcrumb; let last = $last) {
                  @if (last) {
                    <h2 class="f-w-700">
                      {{ breadcrumb.title | translate }}
                    </h2>
                  }
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  }
}
